import { Route, BrowserRouter, Routes } from "react-router-dom";
import { UserListPage } from "../../pages/UserListPage";
import { CreateUserPage } from "../../pages/CreateUserPage";
import { EditUserPage } from "../../pages/EditUserPage";
import DashBoardPage from "../../pages/DashBoardPage/DashBoardPage";
import ProfilePage from "../../pages/ProfilePage/ProfilePage";
import { CredMgmtSetPasswordPage } from "../../pages/CredMgmtSetPasswordPage";
import CredMgmtForgotPasswordPage from "../../pages/CredMgmtForgotPasswordPage/CredMgmtForgotPasswordPage";
import { Roles } from "./Roles";
import RoleAssignmentReportPage from "../../pages/RoleAssignmentReportPage/RoleAssignmentReportPage";
import { Footer } from "../Footer";
import UserLastLoginReportPage from "../../pages/UserLastLoginReportPage/UserLastLoginReportPage";
import AccessLogReportPage from "../../pages/AccessLogReportPage/AccessLogReportPage";
import { HotkeysWrapper } from "../../helpers";
import SetPasswordInstructions from "../SetPasswordInstructions/SetPasswordInstructions";
import MsWellDonePage from "../../pages/MsWellDonePage/MsWellDonePage";
import { MsActivationLinkExpired } from "../MsActivationLinkExpired";
import { LangWrapper } from "../../helpers/LangWrapper";
import DaForgotPasswordPage from "../../pages/DaForgotPasswordPage/DaForgotPasswordPage";
import DaResetLinkExpiredPage from "../../pages/DaResetLinkExpiredPage/DaResetLinkExpiredPage";
import DaEmailLinkExpiredPage from "../../pages/DaEmailLinkExpiredPage/DaEmailLinkExpiredPage";
import DaCheckEmailPage from "../../pages/DaCheckEmailPage/DaCheckEmailPage";
import DaResetPasswordPage from "../../pages/DaResetPasswordPage/DaResetPasswordPage";
import DaPasswordSavedPage from "../../pages/DaPasswordSavedPage/DaPasswordSavedPage";
import DaCreateAccountPage from "../../pages/DaCreateAccountPage/DaCreateAccountPage";
import DaAccountCreatedPage from "../../pages/DaAccountCreatedPage/DaAccountCreatedPage";
import DaUnableToLoginPage from "../../pages/DaUnableToLoginPage/DaUnableToLoginPage";

// Create a wrapper for hotkeys
function SecApp() {
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Routes>
        <Route element={<HotkeysWrapper />}>
          <Route
            path="/ciam/v1/:tenant/profile"
            element={
              <ProfilePage
                allowedRoles={[
                  Roles.ADMIN,
                  Roles.PROFILE_VIEWER,
                  Roles.PROFILE_VIEWER_MT,
                  Roles.ADMIN_MT,
                  Roles.ACCESS_LOG_VIEWER_MT,
                ]}
              />
            }
          />

          <Route
            path="/ciam/v1/:tenant/users/create"
            element={<CreateUserPage allowedRoles={[Roles.ADMIN, Roles.ADMIN_MT]} />}
          />
          <Route
            path="/ciam/v1/:tenant/users/edit/:id"
            element={<EditUserPage allowedRoles={[Roles.ADMIN, Roles.ADMIN_MT]} />}
          />
          <Route
            path="/ciam/v1/:tenant"
            element={
              <DashBoardPage
                allowedRoles={[Roles.ADMIN, Roles.PROFILE_VIEWER, Roles.ADMIN_MT, Roles.PROFILE_VIEWER_MT]}
              />
            }
          />
          <Route
            path="/ciam/v1/:tenant/users"
            element={<UserListPage allowedRoles={[Roles.ADMIN, Roles.ADMIN_MT]} />}
          />
          <Route
            path="/ciam/v1/:tenant/reports/role-assignment"
            element={
              <RoleAssignmentReportPage
                allowedRoles={[Roles.ROLE_ASSIGNMENT_VIEWER, Roles.ROLE_ASSIGNMENT_VIEWER_PSA]}
              />
            }
          />
          <Route
            path="/ciam/v1/:tenant/reports/user-last-login"
            element={
              <UserLastLoginReportPage
                allowedRoles={[Roles.LAST_LOGIN_USER_VIEWER, Roles.PSA_LAST_LOGIN_USER_VIEWER]}
              />
            }
          />
          <Route
            path="/ciam/v1/:tenant/reports/access-log"
            element={<AccessLogReportPage allowedRoles={[Roles.ACCESS_LOG_VIEWER_PSA, Roles.ACCESS_LOG_VIEWER_MT]} />}
          />

          <Route path="/ciam/v1/:tenant/accounts/activate" element={<CredMgmtSetPasswordPage />} />
          <Route path="/ciam/v1/:tenant/accounts/change-password" element={<CredMgmtSetPasswordPage />} />
          <Route path="/ciam">
            <Route path=":lang">
              <Route
                path="v1/:tenant/accounts/forgot-password"
                element={
                  <LangWrapper>
                    <CredMgmtForgotPasswordPage />
                  </LangWrapper>
                }
              />
            </Route>

            <Route
              path="v1/:tenant/accounts/forgot-password"
              element={
                <LangWrapper>
                  <CredMgmtForgotPasswordPage />
                </LangWrapper>
              }
            />
          </Route>

          <Route path="/ciam/v1/ms1/accounts/migrate" element={<SetPasswordInstructions />} />
          <Route path="/ciam/v1/ms1/accounts/password-changed" element={<MsWellDonePage />} />
          <Route path="/ciam/v1/ms1/accounts/link-expired" element={<MsActivationLinkExpired />} />
          <Route path="/ciam/v1/:tenant/accounts/da-forgot-password" element={<DaForgotPasswordPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-reset-link-expired" element={<DaResetLinkExpiredPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-email-link-expired" element={<DaEmailLinkExpiredPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-check-email" element={<DaCheckEmailPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-reset-password" element={<DaResetPasswordPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-create-account" element={<DaCreateAccountPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-account-created" element={<DaAccountCreatedPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-password-saved" element={<DaPasswordSavedPage />} />
          <Route path="/ciam/v1/:tenant/accounts/da-unable-to-login" element={<DaUnableToLoginPage />} />
        </Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default SecApp;
